/**
 * Styled Components - Created by david on 12/02/18.
 */
import Checkbox from 'antd/lib/checkbox'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'
import Tooltip from 'antd/lib/tooltip'
import Dropdown from 'antd/lib/dropdown'
import styled from 'styled-components'
import { 
  GRAY_DARK, 
  GREEN_BRIGHT, 
  WHITE, 
  RED, 
  BLACK_LABEL, 
  GRAY_LIGHTEST, 
  BLACK_SHADOW, 
  GRAY, 
  BLUE_LIGHT, 
  BLACK,
  RED_TRANSPARENT,
  BLUE
} from '../../../theme/colors'

type StyledProps = {
  backgroundColor?: string
  selectProduct?: boolean
  isProDesign?: boolean
  showTooltips?: boolean
  designLab?: boolean
  selectedIndex?: number
  fromTop?: boolean
  fromYotpo?: boolean
  hide?: boolean
  secondary?: boolean
  fitContainer?: boolean
  isBeingCompared?: boolean
}

interface ButtonProps {
  secondary?: boolean
  maxMargin?: boolean
}

export const ImageContainer = styled.div`
  user-select: none;
  position: relative;
  cursor: pointer;
  ${({ backgroundColor }: StyledProps) =>
    backgroundColor ? `background-color: ${backgroundColor}` : ''};
  width: 100%;
  padding: ${({ backgroundColor, selectProduct, designLab }: StyledProps) => {
    if (selectProduct || designLab) {
      return '0'
    }
    return backgroundColor ? '10px' : '10px 0'
  }}
  text-align: center;
  border: ${({ backgroundColor }: StyledProps) =>
    backgroundColor ? `1px solid ${WHITE}` : 'none'};
  @media (min-width: 321px) and (max-width: 480px) {
    width: 100%;
  }
  @media only screen and (max-width: 320px) {
    height: 130px;
    width: 100%;
  }
`

export const DeleteButton = styled(Icon)`
  font-size: 16px;
  top: 5px;
  right: 5px;
  display: block;
  position: absolute;
  z-index: 9;
  transition: all .25s;
  padding: 6px;
  border-radius: 50%;
  &:hover {
    color: ${WHITE};
    background: ${RED};
  }
  @media (min-width: 320px) and (max-width: 767px) {
    filter: drop-shadow(0px 0px 2px black);
    color: ${WHITE};
  }
`

export const Page = styled.div`
  user-select: none;
  height: 200.29px;
  text-align: center;
  ${({ fromYotpo }: StyledProps) => fromYotpo ? `
    background: ${GRAY_LIGHTEST};
    border-radius: 5px;
  ` : ''}
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    height: 180px;
  }
`

export const Image = styled.img`
  object-fit: cover;
  user-select: none;
  height: 200.29px;
  width: 100%;
  ${({ secondary }: StyledProps) => secondary ? `
    width: calc(100% + 20px);
    margin-left: -10px;
    height: calc(100% + 20px);
    margin-top: -10px;
    border-radius: 3px;
  ` : ''}
  @media (min-width: 321px) and (max-width: 480px) {
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 320px) {
    height: 115px;
    width: 100%;
    margin: 0;
  }
`

export const QuantityLabel = styled.div`
  position: absolute;
  right: 5px;
  top: 12px;
  color: ${WHITE};
`

export const ImageTop = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  position: absolute;
  justify-content: space-between;
  padding: 4px 8px;
  width: 100%;
  cursor: pointer;
  @media (min-width: 320px) and (max-width: 480px) {
    width: ${({ selectProduct, isProDesign }: StyledProps) =>
    selectProduct || isProDesign ? `100%` : '100px'};
    &::after {
      content: "${({ selectedIndex }: StyledProps) => selectedIndex}";
      color: ${WHITE};
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 15px;
      background: ${RED};
      right: 5px;
      top: 5px;
      display: ${({ selectedIndex }: StyledProps) => selectedIndex ? 'flex' : 'none'};
      justify-content: center;
      align-items: center;
    }
  }
  ${({ secondary }: StyledProps) => secondary ? `
    bottom: 4px;
    right: 4px;
    width: fit-content;
  ` : ''}
`

export const CheckboxSelection = styled(Checkbox)`
  position: absolute;
  right: 10px;
  bottom: 8px;
  z-index: 3;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  .ant-checkbox-inner {
    border: 1px solid #a7a7a7;
  }
  @media (max-width: 698px) {
    .ant-checkbox-inner {
      width: 20px;
      height: 20px;
    }
    .ant-checkbox-inner:after{
      left: 6.571429px;
      top: 3.142857px;
    }
  }
`

export const SelectLabel = styled.div`
  font-size: 10px;
  line-height: 1;
  color: #cad3d6;
  margin-right: -8px;
  margin-bottom: -4px;
  margin-top: 1px;
`

export const MenuActions = styled.div`
  position: absolute;
  left: 7px;
  top: 6px;
  background: #e3e8ea;
  border-radius: 3px;
  padding: 4px;
  padding-left: 4px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: all .25s;
  &:hover {
    background: #c9d0d3;
    cursor: pointer;
    border: 1px solid darkgray;
  }
  @media (max-width: 698px) {
    left: 6px;
    top: 5px;
    background: #e1e6e8;
  }
`

export const DotsIcon = styled(Icon)`
  filter: contrast(5);
  color: ${BLACK};
  font-size: 16px;
  @media (max-width: 698px) {
    font-size: 18px;
  }
`

export const TopContainer = styled.div`
  user-select: none;
  height: 35.04px;
  width: 36px;
  background-color: #e61737;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ThumbnailImage = styled.img`
  width: 100%;
  max-width: 220px;
  box-shadow: ${({ isBeingCompared }: StyledProps) => isBeingCompared ? '0px 0px 8px 1px #00aaff' : 'none'};
  height: ${({ fitContainer }: StyledProps) => (fitContainer ? '110px' : '212px')};
  object-fit: cover;
  border-radius: 3px;
  transition: all .25s;
  background: ${({ isProDesign }: StyledProps) => (isProDesign ? GRAY_LIGHTEST : 'unset')};
  ${({ hide }: StyledProps) => hide ? `
    max-width: 130px;
    height: 56px;
  ` : ''}
  @media (max-width: 767px) {
    max-width: ${({ isProDesign }: StyledProps) => (isProDesign ? '162px' : '220px')};
  }
`

export const ProStatus = styled.div`
  width: 70%;
  padding: 10px 0;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  background: ${BLACK_LABEL};
  border-radius: 3px;
  color: ${({ backgroundColor }: StyledProps) => backgroundColor || WHITE};
`

export const ProLabel = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  width: 100%;
  top: 40%;
`

export const TopText = styled.div`
  user-select: none;
  color: #ffffff;
  font-size: 8px;
  font-weight: 500;
  line-height: 11px;
  text-align: center;
  text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
`

export const QuickView = styled.div`
  z-index: 1;
  transition: all 0.25s ease;
`

export const QuickIcon = styled.img`
  max-width: 17px;
  transition: all .25s;
  background: #f1f4f561;
  border-radius: 25px;
  &:hover {
    cursor: pointer;
    filter: brightness(1) drop-shadow(0px 0px 1px gray);
  }
`

export const Arrows = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 110px;
  width: 100%;
  justify-content: space-between;
  padding: 0 5px;
`

export const Arrow = styled.img``

interface ButtonContainerProps {
  myLockerList?: boolean
  fromTop?: boolean
  isBeingCompared?: boolean
  showCompareButton?: boolean
}

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: ${({ myLockerList, showCompareButton }: ButtonContainerProps) =>
    myLockerList ? '70px' : (showCompareButton ? '140px' : '170px')};
  user-select: none;
  width: 100%;
  ${({ fromTop }: ButtonContainerProps) => fromTop ? `
    top: 140px;
  ` : ''}
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
`

export const ButtonContainerCustomize = styled.div`
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: ${({ myLockerList }: ButtonContainerProps) =>
    myLockerList ? '70px' : '170px'};
  user-select: none;
  width: 100%;
  ${({ fromTop }: ButtonContainerProps) => fromTop ? `
    top: 140px;
  ` : ''}
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    top: ${({ myLockerList }: ButtonContainerProps) =>
      myLockerList ? '70px' : '144px'};
  }
`

export const ButtonCompareContainer = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  user-select: none;
  bottom: 12px;
  right: 2px;
  z-index: 3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    bottom: 14px;
    right: 4px;
  }
`

export const ButtonCompareContainerStore = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  user-select: none;
  bottom: 6px;
  left: 8px;
  z-index: 3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    bottom: 14px;
    right: 4px;
  }
`

export const AddToStore = styled.div`
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: calc(40% + 34px);
  user-select: none;
  width: 100%;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
`

export const ActionButton = styled.div`
  user-select: none;
  background-color: ${({ secondary }: ButtonProps) =>
    secondary ? RED_TRANSPARENT : '#fffffff0'};
  color: ${({ secondary }: ButtonProps) => (secondary ? WHITE : GRAY_DARK)};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 68%;
  transition: all .25s;
  margin-top: 10px;
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const ButtonContainer2 = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  left: 0;
  position: absolute;
  top: ${({ myLockerList }: ButtonContainerProps) =>
    myLockerList ? '92px' : '170px'};
  user-select: none;
  width: 100%;
  ${({ fromTop }: ButtonContainerProps) => fromTop ? `
    top: 140px;
  ` : ''}
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
`

export const DiscontinuedButton = styled.div`
  user-select: none;
  background-color: #e65317a3;
  color: ${WHITE};
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 68%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: #e65317d1;
  }
`

export const CertificationButton = styled.div`
  user-select: none;
  background-color: #ffee6dad;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 87%;
  margin-top: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: #ffee6dd9;
  }
`

export const CustomizeButton = styled.div`
  user-select: none;
  background-color: ${({ myLockerList }: ButtonContainerProps) => myLockerList ? '#179ce6e0' : '#e61737b3'};
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.15);
  }
`

export const CompareButton = styled.div`
  color: #fff;
  font-size: 9px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid ${BLUE};
  background-color: ${({ isBeingCompared }: ButtonContainerProps) => isBeingCompared ? '#00aaff9a' : '#1d1d1d45'};
  padding: 0px 8px;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: brightness(1.15);
    background-color: #00aaff9a;
  }
  @media (max-width: 698px) {
    font-size: 11px;
    padding: 4px 12px;
    background-color: ${({ isBeingCompared }: ButtonContainerProps) => isBeingCompared ? '#00aaff9a' : '#1d1d1d5c'};
  }
`

interface ProApprovedProps {
  proAssigned?: boolean
}

export const ProApproved = styled.div`
  background-color: ${({ proAssigned }: ProApprovedProps) =>
    proAssigned ? GREEN_BRIGHT : GRAY_DARK};
  color: ${WHITE};
  padding: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
`

export const CheckboxContainer = styled.div`
  @media (min-width: 320px) and (max-width: 480px) {
    display: ${({ selectedIndex }: StyledProps) =>
    selectedIndex ? 'none' : 'inline-block'};
  }
`

export const StatusFlag = styled.img`
  position: absolute;
  height: 50px;
  right: 5px;
  top: 5px;
  z-index: 8;
  ${({ showTooltips }: StyledProps) => showTooltips ? `
    animation: pulse 2s 2s infinite;
    @keyframes pulse {
      0% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
      }
    
      70% {
        transform: scale(1);
        filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0));
      }
    
      100% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
      }
    }
  ` : ''}
`

export const InfoIcon = styled.img`
  height: 28px;
  position: absolute;
  right: -9px;
  top: -13px;
  z-index: 9;
  filter: brightness(140%) saturate(200%) drop-shadow(0px 2px 2px ${GRAY_DARK});
  animation: wobble-hor-bottom 1s 1s 4 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-15px);}
    60% {transform: translateY(-7px);}
  }
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const BackgroundLayer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: ${BLACK_SHADOW};
  width: 100vw;
  height: 100vh;
  z-index: -1;
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  max-width: 256px;
  width: 100%;
  font-size: 12px;
  color: ${BLACK};
`

export const ScheduledDate = styled.div`
  width: fit-content;
  position: absolute;
  top: -10px;
  left: 8px;
  padding: 8px;
  background: ${WHITE};
  box-shadow: 0px 1px 3px 0px ${GRAY};
  border-radius: 6px;
  color: ${BLUE_LIGHT};
  font-weight: bold;
`

export const DateIcon = styled(Icon)`
  margin-right: 8px;
`

export const TestPrintIcon = styled.img`
  max-width: 22px;
  position: absolute;
  left: 12px;
  bottom: 10px;
`

export const TestPrintIconPro = styled.img`
  max-width: 22px;
  position: absolute;
  left: 12px;
  bottom: 20px;
`

export const ImportedIcon = styled(Icon)`
  font-size: 12px;
  position: absolute;
  left: -3px;
  top: -9px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 4px;
  border: 1px solid #ece3ff;
  box-shadow: none;
`

export const DropdownStyled = styled(Dropdown)`
  z-index: 9;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailRecommended/ProductSlide/styledComponents.tsx